import React, { Component } from 'react';
import moment from 'moment';
import RavenUtil from '../../common/ravenUtil';
import { ModalLoadingPage } from '../../common/loadingPage';
import { strings } from '../../../localization';

export default class LiveFeed extends Component {

    constructor(props) {

        super(props);
        this.state = {
            // Set the initial camera setting from props if available
            ravenCameraIndex: this.props.cameraIndex ? this.props.cameraIndex : 0,
            updatesDelayed: undefined,
        };
    }

    onSwitchPreviewCamera = (e) => {

        // Notify the outside of the camera switch
        if(this.props.onCameraSwitch)
        {
            this.props.onCameraSwitch(this.state.ravenCameraIndex === 0 ? 1 : 0);
        }

        this.setState({
            ravenCameraIndex: this.state.ravenCameraIndex === 0 ? 1 : 0,
        });
    }

    render() {

        // console.log('live feed state', this.state);
        var showImage =
            this.props.liveMedia &&
            this.props.liveMedia[this.state.ravenCameraIndex].imageData &&
            this.props.liveMedia[this.state.ravenCameraIndex].imageData.length > 0;
        var imageElement = null;
        //unplugged (OR can't connect?)
        if (this.props.unplugged) {
            imageElement = (
                <div>
                    <img src="/images/img-placeholder.jpg" width="480" height="270" />
                    <div className="loading-overlay">
                        <div className="timeout">
                            <i className="material-icons icon-lg">signal_cellular_connected_no_internet_4_bar</i>
                            <h3>{strings.formatString(strings.db_raven_offline)}</h3>
                        </div>
                    </div>
                </div>
            );
        }
        //not unplugged and connecting (slow updates undefined)
        if (!this.props.unplugged && this.state.updatesDelayed === undefined) {
            imageElement = (
                <div>
                    <img src="/images/img-placeholder.jpg" width="480" height="270" />
                    <div className="loading-overlay">
                        <ModalLoadingPage message={strings.db_live_feed_connecting} />
                    </div>
                </div>
            );
        }

        var switchCameraButton = null;
        var timestampLabel = null;
        var imageinfo = RavenUtil.getPreviewImageHTML(this.props.raven, this.state.ravenCameraIndex, 480, 270);
        if(imageinfo)
        {
            imageElement = imageinfo.image;
            timestampLabel = imageinfo.timestamp;
            switchCameraButton = (
                <button className="btn btn-icon btn-bottom-right-corner" onClick={this.onSwitchPreviewCamera} title={strings.formatString(strings.btn_switch_camera)}>
                    <i className="material-icons">switch_video</i>
                </button>
                );
        }

        return (
            <div className="col-12 image-panel panel-wrapper">
                <div className="row section-wrapper live-feed">
                    <div className="col-12 section-body">
                        <div className="img-wrapper">
                            {imageElement}
                            {switchCameraButton}
                            {timestampLabel}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
